import React, { Component } from "react";

class PasswordInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordType: "password",
    };
  }

  togglePassword = () => {
    const { passwordType } = this.state;
    if (passwordType === "password") {
      this.setState({ passwordType: "text" });
    } else this.setState({ passwordType: "password" });
  };

  render() {
    const { passwordType } = this.state;
    const { name, label, error, req, icon, ...rest } = this.props;
    return (
      <div className={`form-group ${req ? "required" : ""}`}>
        {label && (
          <label htmlFor={name} className="form-control-label">
            {icon && <i className={`fa ${icon}`} style={{ marginRight: "6px" }} />}
            {label}
          </label>
        )}
        <div className="wf-password-input-wrap" style={{ position: "relative", width: "100%" }}>
          <input
            {...rest}
            type={passwordType}
            id={name}
            name={name}
            className="form-control wf-password-control"
            placeholder={label}
            style={{ paddingRight: "38px" }}
          />
          <button
            type="button"
            className="wf-password-toggle-btn"
            onClick={this.togglePassword}
            aria-label={passwordType === "password" ? "Show password" : "Hide password"}
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              width: "38px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "transparent",
              border: "none",
              color: "#64748b",
              cursor: "pointer",
              padding: 0,
              outline: "none",
              zIndex: 2,
            }}
          >
            {passwordType === "password" ? (
              <i className="fa fa-eye-slash" aria-hidden="true" />
            ) : (
              <i className="fa fa-eye" aria-hidden="true" />
            )}
          </button>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    );
  }
}

export default PasswordInput;
